import React from 'react';

import { Routes, Route, Navigate } from 'react-router-dom';

import LandingPage from './forms/LandingPage';
import Form2 from './forms/Form2';
import Form3 from './forms/Form3';
import Form4 from './forms/Form4';
import Form5 from './forms/Form5';
import Form6 from './forms/Form6';
import Form7 from './forms/Form7';
import FormEnding from './forms/FormEnding';

import { NAVIGATION_PATHS } from '../constants/constants';
import useLocationTracking from '../hooks/useLocationTracking';

const Quoter = () => {
  useLocationTracking();
  return (
    <Routes>
      <Route path={`${NAVIGATION_PATHS[1]}`} replace element={<LandingPage />} />
      <Route path={`${NAVIGATION_PATHS[2]}`} replace element={<Form2 />} />
      <Route path={`${NAVIGATION_PATHS[3]}`} replace element={<Form3 />} />
      <Route path={`${NAVIGATION_PATHS[4]}`} replace element={<Form4 />} />
      <Route path={`${NAVIGATION_PATHS[5]}`} replace element={<Form5 />} />
      <Route path={`${NAVIGATION_PATHS[6]}`} replace element={<Form6 />} />
      <Route path={`${NAVIGATION_PATHS[7]}`} replace element={<Form7 />} />
      <Route path={`${NAVIGATION_PATHS[8]}`} replace element={<FormEnding />} />
      <Route path="*" element={<Navigate to={`${NAVIGATION_PATHS[1]}`} replace />} replace />
    </Routes>
  );
};

export default Quoter;
